import * as React from "react"
const ForwardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={ 18 }
    height={ 18 }
    fill="currentColor"
    viewBox="0 0 24 24"
    { ...props }
  >
    <path d="M11 16H3V8h8V2l10 10-10 10v-6m2-9v3H5v4h8v3l5-5-5-5Z" />
  </svg>
)

export default ForwardIcon
